import {
  SARIconThemeColor,
  setMobileBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileSubTextColor,
  setMobileTextColor,
} from "../../../utility";
import no_image from "../../../images/No_Image_Available.jpg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { t } from "i18next";
import SuggestionsFavoriteIcon from "./suggestionsFavoriteIcon";

const onImageError = (e) => {
  e.target.src = no_image;
};

const AiSuggestionsItemCard = ({
  item,
  qrCode,
  in_root,
  qrName,
  sympole,
  handleFavorite,
  favorites,
  suggested,
  handleOpenItemDialog,
}) => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  const openItem = () => {
    handleOpenItemDialog(item);
  };

  return (
    <div
      className="ai-suggestion-full-card col-md-12 mt-3 mx-auto position-relative alignByLang"
      style={{
        height: item.sold_out === 1 ? "150px" : "130px",
        backgroundColor:
          localStorage.getItem("theme") === "dark" ||
            localStorage.getItem("theme") === "light" ||
            localStorage.getItem("theme") === "costomize"
            ? setMobileBackColor()
            : "",
        borderColor:
          localStorage.getItem("theme") === "dark" ||
            localStorage.getItem("theme") === "light" ||
            localStorage.getItem("theme") === "costomize"
            ? setMobileCardBorderColor()
            : setMobileCardBorderColor(),
        borderWidth: 1,
        padding: "6px",
      }}
      onClick={openItem}
    >
      <div style={{ width: "40%" }}>
        <img
          style={{
            width: "90px",
            height: "90px",
          }}
          className="cursor"
          src={item.image || no_image}
          onError={onImageError}
        />
        <SuggestionsFavoriteIcon
          item={item}
          handleFavorite={handleFavorite}
          favorites={favorites}
          suggested={suggested}
        />
      </div>
      <div className="ai-suggestion-full-card-2">
        <h2
          className="ai-suggestion-item-name mb-0 cursor sub-font"
          style={{
            fontSize: "14px", // Smaller font size for mobile
            color: setMobileTextColor(),
          }}
          onClick={openItem}
        >
          {item.name}
        </h2>

        <div
          className={`position-absolute`}
          style={
            localStorage.getItem("lang") === "ar" ||
              localStorage.getItem("lang") === "fa"
              ? {
                bottom: "8px",
                left: "8px",
              }
              : {
                bottom: "8px",
                right: "8px",
              }
          }
        >
          {item.has_price_options ? (
            <strong
              className="head-font"
              style={{
                color:
                  localStorage.getItem("theme") === "costomize"
                    ? setMobileTextColor()
                    : "#6ba5f2 ",
                fontSize: "14px",
              }}
            >
              {item.lowest_price_option
                ? t("STARTS AT") + " " + item.lowest_price_option
                : item.price || 0}{" "}
              {sympole ? sympole === "SAR" ? <img style={{width:"20px",height:"20px"}} src={SARIconThemeColor()}  className="mr-1" /> : sympole : ""}

            </strong>
          ) : (
            <strong
              className="head-font"
              style={{
                color:
                  localStorage.getItem("theme") === "costomize"
                    ? setMobileTextColor()
                    : "#6ba5f2 ",
                fontSize: 14,
              }}
            >
              {item?.old_price > 0 && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "red",
                  }}
                >
                  {item.old_price || ""}
                </span>
              )}{" "}
              {item.price} {sympole ? sympole === "SAR" ? <img style={{width:"20px",height:"20px"}} src={SARIconThemeColor()}  className="mr-1" /> : sympole : ""}

            </strong>
          )}
        </div>
      </div>
    </div>
  );
};

export default AiSuggestionsItemCard;
